// extracted by mini-css-extract-plugin
export default {"container":"zK-z","error":"AK-z","disabled":"BK-z","submit":"CK-z","option":"DK-z","success":"EK-z","failure":"FK-z"};